<template>
  <div>
        <div class="layui-card" style="min-height:500px">
            <div class="layui-card-body">
                <div class="layui-form  layui-form-pane" lay-filter="example">
                    <p class="titleProject">项目基本信息</p>
                    <table class="layui-table" style="width: 100%;">
                        <colgroup>
                            <col width="150">
                            <col width="200">
                            <col>
                        </colgroup>
                        <tbody>
                            <tr>
                                <td class="JBtitle">项目编号:</td>
                                <td class="JBvalue" id="PrjNo">
                                    {{bulletinList.PrjNo}}
                                    </td>
                                <td class="JBtitle">项目名称:</td>
                                <td class="JBvalue" id="PrjName">
                                    {{bulletinList.PrjName}}
                                    </td>
                            </tr>
                            <tr>
                                <td class="JBtitle">采购单位:</td>
                                <td class="JBvalue" id="YzCompanyName">
                                    {{bulletinList.yzCompanyName}}
                                    </td>
                                <td class="JBtitle">经办人:</td>
                                <td class="JBvalue" id="YzCompanyLinkMan">
                                    {{bulletinList.YzCompanyLinkMan}}
                                    </td>
                            </tr>
                            <tr>
                                <td class="JBtitle">联系电话:</td>
                                <td class="JBvalue" id="YzCompanyLinkPhone">
                                    {{bulletinList.yzCompanyLinkPhone}}
                                    </td>
                                <td class="JBtitle">成交发布时间:</td>
                                <td class="JBvalue" id="BookSellMoney">
                                    {{bulletinList.CloseDate}}
                                    </td>
                            </tr>
                            <tr>
                                <td class="JBtitle">报价方式:</td>
                                <td class="JBvalue" colspan=3>
                                    {{bulletinList.QuoteType}}
                                    </td>
                            </tr>
                            <tr>
                                <td class="JBtitle">开标备注:</td>
                                <td class="JBvalue" id="Remark" colspan=3>
                                    {{bulletinList.CloseRemark}}
                                    </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div style="margin-top:25px" class="layui-from" id="CusTable">
                  <table class="layui-table" style="width: 100%;">
                        <tbody>
                            <tr>
                                <td>标段名称</td>
                                <td>成交人</td>
                                <td>预算</td>
                                <td>成交报价</td>
                            </tr>
                            <tr v-for="(item,index) of bulletinList.ZbInfoList" :key="index">
                                <td>{{ item.SectName }}</td>
                                <td>{{ item.CustomerName }}</td>
                                <td>{{ item.BasePrice + '元'}}</td>
                                <td>{{ item.FinallyPrice}}{{bulletinList.QuoteTypeTXT}}</td>
                            </tr>
                        </tbody>
                    </table>
                    <!-- <el-table style="width: 100%" bordered :columns="columns" :data="bulletinList.ZbInfoList" :rowKey="record=>record.Name" :pagination="false">
                      <el-table-column
                        prop="SectName"
                        label="标段名称" />
                      <el-table-column
                        prop="CustomerName"
                        label="成交人" />
                      <el-table-column
                        prop="BasePrice"
                        label="预算">
                          <template slot-scope="scope">
                              {{ scope.row.BasePrice + "元" }}
                          </template>
                      </el-table-column>
                      <el-table-column
                        prop="FinallyPrice"
                        label="成交报价">
                          <template slot-scope="scope">
                              {{ scope.row.FinallyPrice}}{{bulletinList.QuoteTypeTXT}}
                          </template>
                      </el-table-column>
                    </el-table> -->
                </div>
                <div class="layui-from" style="text-align:center;margin-top:23px">
                    <button id="wjs" class="layui-btn layui-btn-normal" @click="baojia()">查看招标公告</button>
                    <button id="wjs" v-if="this.GZGGList.length>0" style="margin-left:15px" class="layui-btn layui-btn-normal" @click="view()">查看更正公告</button>
                </div>
            </div>
        </div>
        <a-modal
        title="查看更正公告   "
        :visible="visible"
        :width="1200"
        :maskClosable="false"
        @cancel="handleCancel"
        cancelText="关闭"
        >
             <template slot="footer">
                <a-button @click="handleCancel">关闭</a-button>
            </template>
            <div>
                <a-table style="width: 100%" bordered :columns="GZcolumns" :data-source="GZGGList" :rowKey="record=>record.AutoId" :pagination="false">
                    <template slot="AutoId" slot-scope="text">
                            <a v-on:click="viewArticle(text)">查看</a>
                        </template>
                </a-table>
                <div style="margin-top: 23px;text-align: center;"><h1>{{Vtitle}}</h1></div>
                <div style="margin: 15px 60px;" v-html="htmlText"></div>
            </div>
        </a-modal>
    </div>
</template>
<script>
const columns = [
  {
    title: '标段名称',
    dataIndex: 'SectName',
    width: 210
  },
  {
    title: '成交人',
    dataIndex: 'CustomerName',
    width: 190
  },
  {
    title: '预算',
    dataIndex: 'BasePrice',
    width: 80,
    scopedSlots: { customRender: 'BasePrice' }
  },
  {
    title: '成交报价',
    dataIndex: 'FinallyPrice',
    width: 80,
    scopedSlots: { customRender: 'FinallyPrice' }
  }
]
const GZcolumns = [
  {
    title: '公告标题',
    dataIndex: 'BulletinTitle',
    width: 300
  },
  {
    title: '操作',
    dataIndex: 'AutoId',
    width: 10,
    scopedSlots: { customRender: 'AutoId' }
  }
]
export default {
  name: 'bulletin-text',
  props: {
    TextList: {
      type: Object,
      default () {
        return {
          prjId: ''
        }
      }
    }
  },
  data () {
    return {
      columns,
      GZcolumns,
      bulletinList: {},
      GZGGList: {},
      visible: false,
      htmlText: '',
      Vtitle: ''
    }
  },
  created () {
    this.$http.get('/ztbapi/api/Notoken/GetOnlineInquireZbBulletin?PrjId=' + this.$route.query.prjId).then((res) => {
      this.bulletinList = res.data.Body.Data
      this.GZGGList = res.data.Body.Data.CorrectionNotices
      if (this.GZGGList.length > 0) {
        this.htmlText = this.GZGGList[0].BulletinContent
        this.Vtitle = this.GZGGList[0].BulletinTitle
      }
    })
  },
  methods: {
    baojia () {
      window.open('/detail?type=1&prjId=' + this.TextList.prjId)
    },
    view () {
      this.visible = true
    },
    handleCancel () {
      this.visible = false
    },
    viewArticle (id) {
      this.GZGGList.forEach(item => {
        if (item.AutoId === id) {
          this.htmlText = item.BulletinContent
          this.Vtitle = item.BulletinTitle
        }
      })
    }
  }
}
</script>
<style lang="less">
        body {
            padding-top: 0px !important;
        }

        .dtree-theme-item-this {
            background-color: transparent !important;
        }

        .JBtitle {
            background-color: #FBFBFB;
            width: 17%;
            text-align: center;
        }

        .JBvalue {
            width: 33%;
        }

        textarea {
            resize: none;
        }

        .layui-form-label {
            width: 16% !important;
        }

        .layui-input-inline {
            width: 30% !important;
        }

        .layui-input-block {
            margin-left: 230px !important;
        }

        #Remark {
            width: 80% !important;
            line-height: 36px;
            min-height: 38px;
            border:1px solid #e6e6e6;
            box-sizing: border-box;
        }

        .layui-table-cell {
            height: auto;
            overflow: visible;
            text-overflow: inherit;
            white-space: normal;
        }
        .titleProject {
            color: #222;
            margin: 0;
            font-size: 16px;
            padding: 16px 24px 6px 24px;
            font-weight: bold;
        }

        #ProjectEdit .layui-form-label {
            width: 32%;
        }

        #ProjectEdit .layui-form-item .layui-input-inline {
            width: 40%;
        }

        /* 修改layui */
        .layui-form-item .layui-inline{
            margin-bottom: 0px;
        }
        .layui-form-item .layui-form-checkbox[lay-skin=primary]{
            margin-top: 0;
        }
        td{
            padding: 9px 15px!important;
        }
        .layui-btn {
            display: inline-block;
            height: 38px;
            line-height: 38px;
            padding: 0 18px;
            background-color: #1E9FFF;
            color: #fff;
            white-space: nowrap;
            text-align: center;
            font-size: 14px;
            border: none;
            border-radius: 2px;
            cursor: pointer;
        }
        table td, table th {
            border-bottom: 1px solid #e6e6e6!important;
            border-right: 1px solid #e6e6e6!important;
        }
        table {
            border-top: 1px solid #e6e6e6!important;
            border-left: 1px solid #e6e6e6!important;
        }
        #CusTable .ant-table-thead > tr > th {
            padding: 8px 16px;
        }
        .el-table{
            font-size: 14px!important;
        }
        .layui-card .el-table__empty-block{
            width: 1530px!important;
        }
        .layui-card table{
            width: 1530px!important;
        }
        .layui-card col{
            width: 180px!important;
        }
</style>



// WEBPACK FOOTER //
// src/components/WinBulletin/winbulletin.vue